// Podcast episodes — seeded as "Coming soon". Verbatim from the client brief.

export const PODCAST_INTRO =
  "Conversations with the people building and running software in Oman. Written for operators, not for algorithms. New episodes drop when they are worth listening to, not on a schedule.";

export const PODCAST_EPISODES = [
  {
    number: 1,
    slug: "building-a-delivery-platform-in-oman",
    title: "Building a delivery platform in Oman — what actually breaks",
    summary:
      "Dispatch, signal loss and proof of delivery: the problems that only appear once real drivers are on real roads.",
    status: "Coming soon",
  },
  {
    number: 2,
    slug: "pdpl-what-an-auditor-actually-looks-for",
    title: "PDPL: what an auditor actually looks for",
    summary:
      "Consent records, deletion that deletes, and the evidence most organisations cannot produce.",
    status: "Coming soon",
  },
  {
    number: 3,
    slug: "selling-software-to-omani-government",
    title: "Selling software to Omani government — the real process",
    summary:
      "How procurement actually works, and what smaller companies get wrong.",
    status: "Coming soon",
  },
  {
    number: 4,
    slug: "from-family-business-to-digital-business",
    title: "From family business to digital business",
    summary:
      "What changes when the process leaves somebody's head and enters a system.",
    status: "Coming soon",
  },
  {
    number: 5,
    slug: "ai-in-a-forty-person-company",
    title: "AI in a forty-person company — what is worth doing",
    summary:
      "The use cases that pay for themselves, and the ones that quietly do not.",
    status: "Coming soon",
  },
  {
    number: 6,
    slug: "where-your-data-should-live",
    title: "Where your data should live",
    summary:
      "Cost, latency and legal obligation, and why the decision is usually inherited rather than made.",
    status: "Coming soon",
  },
  {
    number: 7,
    slug: "hiring-developers-in-oman",
    title: "Hiring developers in Oman",
    summary:
      "Omanisation, training and keeping good engineers once you have them.",
    status: "Coming soon",
  },
  {
    number: 8,
    slug: "what-gcc-expansion-actually-costs",
    title: "What GCC expansion actually costs",
    summary:
      "Licensing, payments, language and support, from someone who has done it.",
    status: "Coming soon",
  },
];
